const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Event Host component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Events} Events the resource defined to manage Events
 * @argument {EventParticipation} EventParticipation the resource defined to manage EventParticipation
 * @argument {Users} Users the resource defined to manage Users
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 */
app.directive('eventHost', ['Application', 'Authorization', 'Events', 'EventParticipation', 'Users','Categories', 'Analyze', '$q', '$translate', function (Application, Authorization, Events, EventParticipation, Users, Categories, Analyze, $q, $translate) {
  return {
    restrict: 'E',
    scope: {},
    template: require('../../templates/directives/event-host.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var routeParameters = Application.navigation.getRouteParameters();
      self.engage = Authorization.getAuthToken().company && Authorization.getAuthToken().company.engage;
      self.user = Authorization.getAuthToken().user;
      self.isAdmin = function(){
        return self.user.role === 'admin';
      };
      self.victorsTest = null;

      var SearchConfig = function(opts) {
        this.noList = opts.noList;
        this.per_page = opts.per_page || 15;
        this.defaultQuery = opts.defaultQuery || {};
        this.defaultQuery.page = this.defaultQuery.page || 1;
        this.defaultQuery.per_page = this.per_page;
        this.query = this.defaultQuery;
        this.nextAvailable = true;
        this.initialized = false;
        this.searching = false;
        this.active = [];
        this.list = opts.list || [];
      };
      SearchConfig.prototype.load = function() {
        var self = this;
        if (this.loading) {
          return;
        }
        var userFind;
        if (this.searching && this.query._id || this.noList) {
          userFind = Users.find(this.query).$promise;
        }

        if (!userFind) {
          if (!this.list || !this.list.length) {
            return;
          }
          userFind = Users.findFromSet(this.query, {users: this.list}).$promise;  
        }

        this.initialized = true;
        this.loading = true;
        return userFind
        .then(function(users) {
          self.nextAvailable = true;
          self.active = users;
          if (users.length < self.per_page) {
            self.nextAvailable = false;
          }
          self.loading = false;
          if (!users.length && self.query.page > 1) {
            self.query.page--;
            self.load().then(function() {
              self.nextAvailable = false;
            });
          }
        }).catch(function(error) {
          // Add error reporting after rebase here
          Application.messaging.addMessage({type: 'error', duration: 6, text: 'There was an error in finding users'});
          self.loading = false;
        });
      };
      SearchConfig.prototype.updateList = function(list) {
        this.list = list;
      };
      SearchConfig.prototype.search = function(query) {
        query = query || {};
        if (!Object.keys(query).length) {
          this.searching = false;
          this.reset();
          return;
        }
        this.searching = true;
        this.query = query;
        this.query.page = 1;
        this.query.per_page = this.per_page;
        this.load();
      };
      SearchConfig.prototype.reset = function() {
        this.query = JSON.parse(JSON.stringify(this.defaultQuery));
        this.load();
      };
      SearchConfig.prototype.nextPage = function() {
        if (!this.nextAvailable) {
          return;
        }
        this.query.page++;
        this.load();
      };
      SearchConfig.prototype.previousPage = function() {
        if (this.page <= 1) {
          return;
        }
        this.query.page--;
        this.load();
      };

      self.categories = {
        data: null,
        locations: {},
        departments: {},
        organize: function(cats) {
          this.data = cats;
          for (var i = 0; i < cats.length; i++) {
            if (cats[i].location) {
              self.categories.locations[cats[i]._id] = cats[i];
            }
            if (cats[i].department) {
              self.categories.departments[cats[i]._id] = cats[i];
            }
          }
        }
      };

      self.attendees = {
        comms: new SearchConfig({
          per_page: 15,
          defaultQuery: {
            fields: 'first_name,last_name,email,image,linked_departments,linked_locations'
          }
        }),
        selections: [],
        selectedUsers: {},
        select: function(user) {
          var index = this.selections.indexOf(user._id);
          if (index !== -1) {
            this.selections.splice(index, 1);
            this.selectedUsers[user._id] = null;
            return;
          }
          this.selections.push(user._id);
          this.selectedUsers[user._id] = user;
        }
      };

      self.waiting = {
        comms: new SearchConfig({
          per_page: 15,
          defaultQuery: {
            fields: 'first_name,last_name,email,image,linked_departments,linked_locations'
          }
        }),
        selections: [],
        selectedUsers: {},
        select: function(user) {
          var index = this.selections.indexOf(user._id);
          if (index !== -1) {
            this.selections.splice(index, 1);
            this.selectedUsers[user._id] = null;
            return;
          }
          this.selections.push(user._id);
          this.selectedUsers[user._id] = user;
        }
      };

      self.checkIns = {
        comms: new SearchConfig({
          per_page: 15,
          defaultQuery: {
            fields: 'first_name,last_name,email,image,linked_departments,linked_locations'
          }
        }),
        checkedIn: {},
        didNotAttend: {},
        setCheckedIn: function() {
          this.checkedIn = {};
          if (!self.evnt.checked_in || !self.evnt.checked_in.length) {
            return;
          }
          for (var i = 0; i < self.evnt.checked_in.length; i++) {
            this.checkedIn[self.evnt.checked_in[i]] = true;
          }
        },
        setDNAs: function() {
          this.didNotAttend = {};
          if (!self.evnt.did_not_attend || !self.evnt.did_not_attend.length) {
            return;
          }
          for (var i = 0; i < self.evnt.did_not_attend.length; i++) {
            this.didNotAttend[self.evnt.did_not_attend[i]] = true;
          }
        },
        preCancel: function(user) {
          if (this.checkedIn[user._id]) {
            this.checkOut(user);
          }
          if (this.didNotAttend[user._id]) {
            this.cancelNoAttend(user);
          }
        },
        checkIn: function(user) {
          this.comms.loading = true;
          Events.checkIn({event: self.evnt._id, user: user._id}, {}).$promise
          .then(function(result) {
            if (result.checked_in) {
              self.evnt.checked_in = result.checked_in;
              self.checkIns.setCheckedIn();
              if (self.checkIns.checkedIn[user._id]) {
                Application.messaging.addMessage({type: 'success', duration: 5, text: user.first_name + ' ' + user.last_name + ' was successfully checked in.'});
              }
            }
            self.checkIns.comms.loading = false;
          });
        },
        checkOut: function(user) {
          this.comms.loading = true;
          Events.checkOut({event: self.evnt._id, user: user._id}, {}).$promise
          .then(function(result) {
            if (result.checked_in) {
              self.evnt.checked_in = result.checked_in;
              self.checkIns.setCheckedIn();
              if (!self.checkIns.checkedIn[user._id]) {
                Application.messaging.addMessage({type: 'success', duration: 5, text: user.first_name + ' ' + user.last_name + ' was successfully checked out.'});
              }
            }
            self.checkIns.comms.loading = false;
          });
        },
        noAttend: function(user) {
          this.comms.loading = true;
          Events.noAttend({event: self.evnt._id, user: user._id}, {}).$promise
          .then(function(result) {
            if (result.did_not_attend) {
              self.evnt.did_not_attend = result.did_not_attend;
              self.checkIns.setDNAs();
              if (self.checkIns.didNotAttend[user._id]) {
                Application.messaging.addMessage({type: 'success', duration: 5, text: user.first_name + ' ' + user.last_name + ' was marked as not attended.'});
              }
            }
            self.checkIns.comms.loading = false;
          });
        },
        cancelNoAttend: function(user) {
          this.comms.loading = true;
          Events.cancelNoAttend({event: self.evnt._id, user: user._id}, {}).$promise
          .then(function(result) {
            if (result.did_not_attend) {
              self.evnt.did_not_attend = result.did_not_attend;
              self.checkIns.setDNAs();
              if (!self.checkIns.didNotAttend[user._id]) {
                Application.messaging.addMessage({type: 'success', duration: 5, text: user.first_name + ' ' + user.last_name + ' is now awaiting check in.'});
              }
            }
            self.checkIns.comms.loading = false;
          });
        },
      };

      self.removals = {
        loading: false,
        show: false,
        names: [],
        makeModal: function() {
          var selectionBlock = {};
          this.names = [];
          if (self.info.tab === 'attendees') {
            self.attendees.selections.forEach(function(id) {
              if (self.attendees.selectedUsers[id]) {
                self.removals.names.push(self.attendees.selectedUsers[id].first_name + ' ' + self.attendees.selectedUsers[id].last_name)
              }
            });
          }
          if (self.info.tab === 'waitlist') {
            self.waiting.selections.forEach(function(id) {
              if (self.waiting.selectedUsers[id]) {
                self.removals.names.push(self.waiting.selectedUsers[id].first_name + ' ' + self.waiting.selectedUsers[id].last_name)
              }
            });
          }
          if (!this.names.length) {
            return;
          }
          this.show = true;
        },
        cancel: function() {
          this.names = [];
          this.show = false;
        },
        remove: function() {
          if (this.loading) {
            return;
          }
          this.loading = true;
          var removalReqs = []
          var list = [];
          if (self.info.tab === 'attendees') {
            list = self.attendees.selections;
          }
          if (self.info.tab === 'waitlist') {
            list = self.waiting.selections;
          }

          if (!list.length) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: 'There was an error finding users to remove.'});
            return;
          }

          list.forEach(function(id) {
            removalReqs.push(EventParticipation.cancel({eventId: self.evnt._id, userId: id, fields: 'title,wait_list,attendees'}, {}).$promise);
          });

          $q.all(removalReqs)
          .then(function(data) {
            var type = self.info.tab === 'waitlist' ? 'withdraw' : self.info.tab === 'attendees' ? 'signout' : '';
            list.forEach(function(id) {
              Analyze.record({resource: 'events'}, {event: self.evnt._id, user: id, action: type});
            });
            Application.analyticsProvider.trackEvent('event_' + type, {content: self.envt._id, content_type: type, title: self.evnt.title});

            self.info.getLists()
            .then(function() {
              if (type === 'signout') {
                self.attendees.comms.reset();
                self.attendees.selections = [];
                self.attendees.selectedUsers = {};
                if (self.checkIns.comms.initialized) {
                  self.checkIns.comms.reset();
                }
              }
              if (type === 'withdraw') {
                self.waiting.comms.reset();
                self.waiting.selections = [];
                self.waiting.selectedUsers = {};
              }
              self.removals.names = [];
              self.removals.loading = false;
              self.removals.show = false
              Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.allUsersRemoved'], duration: 5});
            });

          });
        }
      };

      self.info = {
        loading: false,
        originalNotes: null,
        attendeeDownload: '',
        waitingDownload: '',
        checkinDownloas: '',
        tab: 'attendees',
        tabMap: {
          attendees: self.attendees,
          checkin: self.checkIns,
          waitlist: self.waiting
        },
        changeTab: function(tab) {
          if (this.tabMap[tab] && this.tabMap[tab].comms && !this.tabMap[tab].comms.initialized) {
            this.tabMap[tab].comms.load();
          }
          this.tab = tab;
        },
        updateAttendeeLists: function(list) {
          self.attendees.comms.updateList(list);
          self.checkIns.comms.updateList(list);
          self.checkIns.setCheckedIn();
          self.attendees.comms.load();
          if (self.checkIns.comms.initialized) {
            self.checkIns.comms.load();
          }
        },
        updateWaitingLists: function(list) {
          self.waiting.comms.updateList(list);
          if (self.waiting.comms.initialized) {
            self.waiting.comms.load();
          }
        },
        goToEvent: function() {
          Application.navigation.goTo('/view/events/' + self.evnt._id);
        },
        editEvent: function() {
          Application.navigation.goTo('/edit/events/' + self.evnt._id);
        },
        getLists: function() {
          return Events.get({
            subresource: routeParameters.id, 
            fields: 'attendees,wait_list'
          }).$promise.then(function(data) {
            self.info.updateAttendeeLists(data.attendees || []);
            self.info.updateWaitingLists(data.wait_list || []);
          }).catch(function(error) {
            // Handle error with getting updated event
          });
        },
        updateNotes: function() {
          self.info.loading = true;
          this.update({notes: self.evnt.notes})
          .then(function(evnt) {
            self.evnt.notes = evnt.notes;
            self.info.originalNotes = evnt.notes
            self.info.loading = false;
            Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.noteChangesSaved'], duration: 5});
          });
        },
        update: function(body) {
          return Events.update({subresource: self.evnt._id, fields: 'notes,registration_disabled,auto_populate_disabled'}, body).$promise
        }
      };

      self.participation = {
        show: false,
        clear: false,
        startCancel: function() {
          this.show = !this.show;
          this.clear = true;
        },
        updateLists: function(evnt) {
          self.evnt.attendees = evnt.attendees ? evnt.attendees : self.evnt.attendees;
          self.evnt.waitlist = evnt.waitlist ? evnt.waitlist : self.evnt.waitlist;
          self.info.updateAttendeeLists(self.evnt.attendees || []);
          self.info.updateWaitingLists(self.evnt.waitlist || []);
        }
      };

      self.registration = {
        showAuto: false,
        loading: false,
        toggle: function() {
          if (!self.evnt.registration_disabled && self.evnt.allow_wait) {
            this.showAuto = true;
            return;
          }
          self.registration.loading = true;
          self.info.update({registration_disabled: !self.evnt.registration_disabled})
          .then(function(evnt) {
            self.registration.loading = false;
            self.registration.showAuto = false;
            self.evnt.registration_disabled = evnt.registration_disabled;
            self.evnt.auto_populate_disabled = evnt.auto_populate_disabled;
            Application.messaging.addMessage({type: 'success', duration: 5, text: 'Registration has been ' + (self.evnt.registration_disabled ? 'disabled.' : 'enabled.')});
          });
        },
        autoToggle: function(type) {
          var update = {
            registration_disabled: true
          };
          if (type === 'yes') {
            update.auto_populate_disabled = true;
          }
          if (type === 'no') {
            update.auto_populate_disabled = false;
          }

          self.registration.loading = true;
          self.info.update(update)
          .then(function(evnt) {
            self.registration.loading = false;
            self.registration.showAuto = false;
            self.evnt.registration_disabled = evnt.registration_disabled;
            self.evnt.auto_populate_disabled = evnt.auto_populate_disabled;
            Application.messaging.addMessage({type: 'success', duration: 5, text: 'Registration has been ' + (self.evnt.registration_disabled ? 'disabled.' : 'enabled.')});
          });
        }
      };

      self.initialize = function () {
        self.info.loading = true;
        if (!routeParameters.id) {
          Application.navigation.goToHome();
          return;
        }

        $q.all([
          Events.get({
            subresource: routeParameters.id, 
            fields: 'title,start_date,end_date,attendees,wait_list,notes,max_attendees,allow_wait,max_wait,registration_disabled,auto_populate_disabled,checked_in,did_not_attend'
          }).$promise, Categories.find({
            $or: '4,location,true,department,true',
            sort: 'name,1'
          }).$promise
        ]).then(function(data) {
          self.evnt = data[0];
          self.info.originalNotes = self.evnt.notes ? JSON.parse(JSON.stringify(self.evnt.notes)) : self.evnt.notes;
          self.info.attendeeDownload = Application.API + '/learn/v3/events/' + self.evnt._id + '/attendcsv?authtoken=' + Authorization.getAuthToken().authtoken;
          self.info.waitingDownload = Application.API + '/learn/v3/events/' + self.evnt._id + '/waitcsv?authtoken=' + Authorization.getAuthToken().authtoken;
          self.info.checkinDownload = Application.API + '/learn/v3/events/' + self.evnt._id + '/checkincsv?authtoken=' + Authorization.getAuthToken().authtoken;
          self.categories.organize(data[1]);
          self.info.updateAttendeeLists(self.evnt.attendees || []);
          self.info.updateWaitingLists(self.evnt.wait_list || []);
          self.checkIns.setDNAs();
          self.attendees.comms.load();
          self.info.pastEvent = new Date().valueOf() > new Date(self.evnt.end_date);
        }).catch(function(error) {
          // Handle and report errors after rebase
        });
      };

      $translate(['modules.notifications.unableToGetEvent','manage.host.waitlistTooltip', 'manage.host.allowedTooltip', 'modules.notifications.event_bothEnabled', 'modules.notifications.event_registrationDisabled', 'modules.notifications.event_bothDisabled', 'modules.notifications.allUsersRemoved', 'modules.notifications.allUsersAdded', 'modules.notifications.noteChangesSaved']).then(function(translations){
        self.translations = translations;
        self.initialize();
      });
    }],
    controllerAs: 'host'
  };
}]);
